import type {User} from '@auth0/auth0-react';
import type {Plan} from 'client';

const AMOUNT_OF_PLANS_TO_DISPLAY: number = 5;

export const filterRecentPlans = (
  data: Plan[] | undefined,
  user: User | undefined,
  myPlans: boolean,
  planId: string,
): Plan[] => {
  if (!data || data.length === 0) {
    return [];
  }

  const filteredByOwnership = myPlans ? (user?.sub ? data.filter((plan) => plan.createdBy === user.sub) : []) : data;

  const filteredByExclusion = filteredByOwnership.filter((plan) => plan.id !== planId);

  const sortedPlans = filteredByExclusion.sort((a, b) => {
    const dateA = a.updatedAt ? new Date(a.updatedAt).getTime() : -Infinity;
    const dateB = b.updatedAt ? new Date(b.updatedAt).getTime() : -Infinity;
    return dateB - dateA;
  });

  return sortedPlans.slice(0, AMOUNT_OF_PLANS_TO_DISPLAY);
};
